import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { STATES, STATES_COMPARATOR } from '@ee/common/constants';
import { AddressSuggestion, populateForm } from '@ee/common/models';

@Component({
  selector: 'ee-organization-form',
  template: `
    <div class="section-wrapper" [formGroup]="form">
      <div class="in-row-grid">
        <mat-form-field class="quad-column">
          <mat-label>Company Name</mat-label>
          <input matInput formControlName="company_name" required />
          @if (form?.get('company_name').hasError('required')) {
            <mat-error>Please enter company name.</mat-error>
          }
          <mat-hint>Required</mat-hint>
        </mat-form-field>
        <ee-address-autocomplete
          class="quad-column"
          placeholder="Street Address"
          [required]="true"
          [formControl]="$any(form.get('street_address_1'))"
          (selectionChange)="onAddressSelected($event)"></ee-address-autocomplete>
        <mat-form-field class="quad-column">
          <mat-label>Street Address 2</mat-label>
          <input matInput formControlName="street_address_2" />
          <mat-hint>Optional</mat-hint>
        </mat-form-field>
        <mat-form-field class="double-column">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" required />
          @if (form?.get('city').hasError('required')) {
            <mat-error>Please enter a city.</mat-error>
          }
          <mat-hint>Required</mat-hint>
        </mat-form-field>
        <mat-form-field>
          <mat-label>State</mat-label>
          <mat-select formControlName="state" required>
            @for (state of states | keyvalue: statesComparator; track state) {
              <mat-option [value]="state.key">
                {{ state.value }}
              </mat-option>
            }
          </mat-select>
          @if (form?.get('state').hasError('required')) {
            <mat-error>Please select a state.</mat-error>
          }
          <mat-hint>Required</mat-hint>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Zip Code</mat-label>
          <input matInput mask="00000" formControlName="zip_code" required />
          @if (form?.get('zip_code').hasError('required')) {
            <mat-error>Please enter a zip code.</mat-error>
          }
          <mat-hint>Required</mat-hint>
        </mat-form-field>
      </div>
      @if (!hideBillingFields) {
        <div class="in-row-grid">
          <mat-form-field class="double-column">
            <mat-label>Contact Email</mat-label>
            <input matInput formControlName="main_email" required />
            @if (form?.get('main_email').hasError('required')) {
              <mat-error>Please enter a contact email for the organization.</mat-error>
            }
            <mat-hint>Required</mat-hint>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Contact Phone Number</mat-label>
            <input matInput mask="(000) 000-0000" formControlName="main_phone_number" required />
            @if (form?.get('main_phone_number').hasError('required')) {
              <mat-error>Please enter a phone number.</mat-error>
            }
            <mat-hint>Required</mat-hint>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Fax Number</mat-label>
            <input matInput mask="(000) 000-0000" formControlName="main_fax_number" />
            <mat-hint>Optional</mat-hint>
          </mat-form-field>
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class OrganizationFormComponent implements OnInit {
  @Input()
    form: UntypedFormGroup;
  @Input()
    hideBillingFields: boolean;
  states = STATES;
  readonly statesComparator = STATES_COMPARATOR;

  constructor() {}

  ngOnInit() {}

  onAddressSelected(suggestion: AddressSuggestion) {
    populateForm(this.form, suggestion);
  }
}
